import React from 'react';
import { MainContentContainer, MainSection } from '../OtherPages.styles';
import SideContainerComponent from '../SideContainer.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import ProductsHero from './Sections/ProductsHero/ProductsHero.component';
import ProductGuidance from './Sections/HelpChoosing/HelpChoosing.component';
import ExploreProducts from './Sections/ExploreProducts/ExploreProducts.component';
import FAQ from './Sections/FAQ/FAQ.component';
import Breadcrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component.jsx';
import TrustedBrands from './Sections/Brands/Brands.component';

const ShopPage = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="Safety Equipment & Supplies in Atlantic Canada"
        description="Shop safety equipment and workplace supplies for businesses across Atlantic Canada, with products for PPE, first aid, traffic safety, fall protection, fire safety, spill response, and more."
      />
      <SideContainerComponent />
      <MainSection>
        <Breadcrumbs
          one="Home"
          oneLink="/"
          two="Shop"
          twoLink="/shop"
          three="Products"
        />
        <ProductsHero />
        <ExploreProducts />
        <TrustedBrands />

        <ProductGuidance />
        <FAQ />
      </MainSection>
    </MainContentContainer>
  );
};

export default ShopPage;
